<template>
    <div class="propoint-update-btn btn btn-dark-blue"
         data-analytics-id="Menu Modal / Open Update Modal"
         :class="{
             hidden: updateAvailable === null,
             'propoint-update-btn--available': updateAvailable === true,
             'propoint-update-btn--uptodate': updateAvailable === false,
         }"
         @click.prevent="showProPointUpdateModal">
        <template v-if="updateAvailable === true">
            <i class="fa-regular fa-window"></i>
            <span class="mobile-only flex--grow flex--shrink text-left">
                {{ l('PROPOINT_UPDATE.UPDATE_AVAILABLE') }}
            </span>
        </template>
        <template v-else-if="updateAvailable === false">
            <i class="fa-regular fa-window"></i>
            <span class="mobile-only flex--grow flex--shrink text-left">
                {{ l('PROPOINT_UPDATE.UP_TO_DATE') }}
            </span>
        </template>
    </div>
</template>

<script>
import { container } from '@/container';
import { mapGetters } from 'vuex';
import { MODAL_NAMES } from '@/vue/modals/MODAL_NAMES';

export default {
    name: 'ProPointUpdate',

    computed: {
        ...mapGetters(['updateAvailable']),
    },

    watch: {
        updateAvailable(newValue, oldValue) {
            // After a reload the initial oldValue === null this is only value when we don't want to show the toast.
            if (oldValue !== null) {
                container.toastFactory.warning(
                    'PROPOINT_UPDATE.UPDATE_AVAILABLE_TOAST',
                    null,
                    {
                        timeOut: 0,
                        extendedTimeOut: 0,
                        tapToDismiss: true,
                    }
                );
            }
        },
    },

    methods: {
        showProPointUpdateModal() {
            container.vueModalFactory.openAndIgnoreResult(MODAL_NAMES.PROPOINT_UPDATE);
        },
    },
};
</script>

<style lang="less">
@import (less, reference) "../../../less/variables.less";

.propoint-update-btn {
    min-width: 0 !important;

    i {
        margin: 0 !important;
    }

    &.propoint-update-btn--available {
        i {
            color: @brand-warning;
        }
    }

    &.propoint-update-btn--uptodate {
        i {
            color: @brand-success;
        }
    }
}

.menu-bar {
    .propoint-update-btn--uptodate {
        // Remove the background and border from the button to leave only the icon.
        background: none;
        border: none;

        &.btn {
            min-width: initial;
        }
    }
}

.menu-modal {
    .propoint-update-btn--uptodate {
        i {
            color: @white;
        }
    }
}
</style>
